import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";
import * as _ from "lodash";
import {Dictionary} from "underscore";


export class OrganizationCollection extends CachingCollection<Backbone.Model> {

    url = () => {
        return window.location.origin + '/api/v1/organizations';
    };

    comparator = (model) => {
        return model.get('name');
    };

    byName = () => {
        return _.keyBy(this.models, ((org) => {
            return org.get('name')
        }));
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/Organizations.ts